import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const navItems = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/news", label: "News" },
  { to: "/admin/services", label: "Activities" },
  { to: "/admin/portfolio", label: "Gallery" },
  { to: "/admin/documents", label: "Documents" },
  { to: "/admin/clients", label: "Alliance" },
  { to: "/admin/settings", label: "Site Settings", settingsOnly: true },
  { to: "/admin/admins", label: "Admins", superOnly: true },
];

const roleLabel = {
  super: "Super Admin",
  admin: "Admin",
  editor: "Editor",
};

export default function AdminLayout() {
  const { user, isSuperAdmin, canEditSettings, role, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <aside
        className="bg-dark text-white p-3"
        style={{ width: 240, flexShrink: 0 }}
      >
        <h5 className="mb-4">CocoClub Admin</h5>
        <nav className="nav flex-column gap-1">
          {navItems
            .filter((item) => {
              if (item.superOnly && !isSuperAdmin) return false;
              if (item.settingsOnly && !canEditSettings) return false;
              return true;
            })
            .map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `nav-link px-2 py-1 rounded ${
                  isActive ? "bg-primary text-white" : "text-white-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <hr className="text-secondary" />
        <div className="small text-white-50 mb-1">{user?.email}</div>
        {role && (
          <div className="small mb-2">
            <span className="badge bg-secondary">{roleLabel[role] || role}</span>
          </div>
        )}
        <button
          className="btn btn-sm btn-outline-light w-100"
          onClick={handleLogout}
        >
          ออกจากระบบ
        </button>
      </aside>
      <main className="flex-grow-1 p-4 bg-light">
        <Outlet />
      </main>
    </div>
  );
}
